import { cn } from "@/lib/cn";

export function Esqueleto({ className }: { className?: string }) {
  return <div aria-hidden className={cn("animate-pulse rounded-md bg-neutral-100", className)} />;
}
